import  { Fragment, useContext, useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import Footer from "./Footer/index";
import TapTop from "./TapTop/index";
import Header from "./Header";
import SideBar from "./Sidebar/Sidebar";
import CheckContext from "../Helper/Customizer";
import ProductContext from "../Helper/product";
import AnimationThemeContext from "../Helper/AnimationTheme";
import ConfigDB from "../Config/ThemeConfig";
import Loader from "./Loader";
import AiAssistantPanel from "../Components/AiAssistant/AiAssistantPanel";
import FairyButton from "../Components/AiAssistant/FairyButton";

const Layout = ({ children, classNames, ...rest }) => {
  const navigate = useNavigate();
  const {   setDefaultClass, setTogglSidebar ,sidebar_types } =
    useContext(CheckContext);
  const { setIsVertical } = useContext(ProductContext);
  const location = useLocation();
  const queryData = location?.search?.split("=")[1]?.toString();
  const { animation } = useContext(AnimationThemeContext);
  const animationTheme =
  localStorage.getItem("animation") ||
  animation ||
  ConfigDB.data.router_animation;
  const sidebarType = localStorage.getItem("sidebar_types");
  let sidebar_types1 = (queryData === "compact-wrapper" || queryData === "horizontal-wrapper")? queryData: localStorage.getItem('sidebar_types') || ConfigDB.data.settings.sidebar.type || sidebar_types;

  const [isAssistantCollapsed, setIsAssistantCollapsed] = useState(() => {
    if (typeof window === "undefined") return false;
    const stored = localStorage.getItem("cpai_ai_assistant_collapsed");
    if (stored !== null) return stored === "true";
    // На узком экране панель ассистента раскрывается во весь экран поверх
    // кабинета. При первом входе с телефона человек видел пустое окно чата
    // вместо своих шагов и наград, и не понимал, куда попал. Поэтому по
    // умолчанию на мобильной она свёрнута, а на широком экране — открыта.
    return window.innerWidth <= 992;
  });

  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.innerWidth <= 992;
  });

  const sideBarReload = ()=>{
  if (sidebarType === "horizontal-wrapper") {
    if (window.innerWidth <= 1200) {
      navigate({ search: `?sidebar=compact-wrapper` });
      setDefaultClass(true);
      sidebar_types1= "compact-wrapper"
    } else {
      navigate({ search: `?sidebar=horizontal-wrapper` });
      setDefaultClass(false);
    }
    }
  } 

  useEffect(() => { 
    const handleResize = () => {
      sideBarReload();
      if (window.innerWidth - 440 <= 759) {
        setTogglSidebar(true);
      } else {
        setTogglSidebar(false);
      }
      if (window.innerWidth <= 1200) {
        setIsVertical(true);
      } else {
        setIsVertical(false);
      }
      setIsMobile(window.innerWidth <= 992);
    };

    sideBarReload();
    setDefaultClass(true);
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return;
    localStorage.setItem(
      "cpai_ai_assistant_collapsed",
      isAssistantCollapsed ? "true" : "false"
    );
  }, [isAssistantCollapsed]);


  return (
    <Fragment>
      <Loader />
      <TapTop />
      <div className={`page-wrapper ${sidebar_types1} `} id="pageWrapper">
        <Header
          isAssistantCollapsed={isAssistantCollapsed}
          setIsAssistantCollapsed={setIsAssistantCollapsed}
        />
        <div className="page-body-wrapper">
          <SideBar />
          <div className={`page-body ${!isMobile ? "page-body--with-assistant" : ""}`}>
            <div className={`page-body__content ${!isMobile && isAssistantCollapsed ? "page-body__content--full" : ""}`}>
              <TransitionGroup {...rest}>
                <CSSTransition key={location.key} timeout={100} classNames={animationTheme} unmountOnExit>
                  <div>
                    <Outlet />
                  </div>
                </CSSTransition>
              </TransitionGroup>
            </div>
            {!isMobile && (
              <div className={`page-body__assistant ${isAssistantCollapsed ? "page-body__assistant--collapsed" : ""}`}>
                <AiAssistantPanel onClose={() => setIsAssistantCollapsed(true)} />
              </div>
            )}
          </div>
          <Footer />
        </div>
      </div>
      {/* Помощница в правом нижнем углу: Максим 22.08.2026 просил персонажа,
          к которому обращаются, а не значок в ряду серых иконок шапки.
          Пока панель открыта, кнопка прячется — иначе она перекрывает
          собственное окно. */}
      <FairyButton
        hidden={!isAssistantCollapsed}
        onClick={() => setIsAssistantCollapsed(false)}
      />

      {isMobile && !isAssistantCollapsed && (
        <div className="ai-assistant-overlay">
          <div className="ai-assistant-overlay__inner">
            <AiAssistantPanel onClose={() => setIsAssistantCollapsed(true)} />
          </div>
        </div>
      )}
      <ToastContainer />
    </Fragment>
  );
};
export default Layout;